export default "__VITE_ASSET__1Pr1fozJ__"